import {Component, Input} from '@angular/core';
import {ViewBreakpointService} from '@common-module/app-services/view-breakpoint.service';
import {UnitAdditionalData} from '@common-module/modelinterfaces/unit-additional-data.model';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SensorValuePipe } from '@common-module/pipes/sensor-value.pipe';

@Component({
    selector: 'app-sensors-card',
    templateUrl: './sensors-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, AsyncPipe, TranslateModule, SensorValuePipe]
})

export class SensorsCardComponent {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  constructor(public viewBreakpointService: ViewBreakpointService) {
  }
}
